import { BASE_URL } from "../constants"
import { GenerateSerialData, NetstatData } from "../entities/NetstatSerial"
import FetchUtils from "../utils/fetch"

class SerialService {
    static async GetSerialReport(start_date: string, end_date: string): Promise<NetstatData[]> {
        const resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/netstat?start_date=${start_date}&end_date=${end_date}`)
        if (resp.status != 200) { throw new Error(resp.message) }

        return resp.data
    }

    static async GenerateSerial(data: GenerateSerialData) {
        const resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/netstat/generate`,
            {
                method: 'POST',
                body: JSON.stringify({ ...data }),
                headers: { "Content-Type": "application/json" }
            })
        if (resp.status != 200) { throw new Error(resp.message) }

        return resp.data
    }

    static async CheckExists(serial_number: string, netstat_type: string) {
        const resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/netstat/exists`,
            {
                method: 'POST',
                body: JSON.stringify({ serial_number: serial_number, netstat_type: netstat_type }),
                headers: { "Content-Type": "application/json" }
            })
        if (resp.status != 200) { throw new Error(resp.message) }

        return resp.data
    }
}

export { SerialService }